import { Injectable } from '@angular/core'
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop'

@Injectable({providedIn: 'root'})
export class NgxFileDropService {

  // A patch method to extract the first dropped file that is found
  // Could update this to handle multiple files in the future
  ngxFileDropToFile = (files: NgxFileDropEntry[]): Promise<File> => {
    return new Promise(resolve => {
      const actualFiles = files.filter(f => f.fileEntry.isFile)
      if (actualFiles.length <= 0) { resolve(null) }

      const firstFileEntry = actualFiles[0].fileEntry as FileSystemFileEntry
      firstFileEntry.file((file: File) => resolve(file))
    })
  }
}
